module.exports = __webpack_public_path__ + "static/img/card_5_1.8368476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_5_1.png
// module id = 2AzN
// module chunks = 0